import React, { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import logo from "../images/logo-full.svg";
import useDocumentTitle from "../components/useDocumentTitle";

function ErrroPage() {
	const error = useRouteError();
	useDocumentTitle("Error");
	console.error(error);

	useEffect(() => {
		// Add 'minimal-layout' class to body
		document.body.classList.add("minimal-layout");
	}, []);

	return (
		<div className="auth-layout">
			<div className="logo">
				<img src={logo} alt="Logo" />
			</div>
			<div className="container">
				<div className="auth-info-container">
					<div id="error-content">
						<h1>Oops!</h1>
						<p>Sorry, an unexpected error has occurred.</p>
						<p className="mb-0">
							<i>{error.statusText || error.message}</i>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ErrroPage;
